import { ReactElement, ReactNode, useEffect, useState } from "react";

export interface DeferProps {
  showAfter?: number;
  hideAfter?: number;
  removeAfter?: number;
  placeholder?: ReactNode;
  onShow?: () => void;
  onHide?: () => void;
  onRemove?: () => void;
  children: ReactNode;
}

const Defer: React.FC<DeferProps> = ({
  showAfter = 1000,
  hideAfter = undefined,
  removeAfter = undefined,
  placeholder = undefined,
  onShow = undefined,
  onHide = undefined,
  onRemove = undefined,
  children,
}): ReactElement<any, any> | null => {
  const [displayPlaceholder, setDisplayPlaceholder] = useState(true);
  const [displayChildren, setDisplayChildren] = useState(false);

  useEffect(() => {
    let hideTimer: NodeJS.Timeout | undefined;
    let removeTimer: NodeJS.Timeout | undefined;

    const showTimer = setTimeout(() => {
      setDisplayChildren(true);
      setDisplayPlaceholder(false);
      if (onShow) onShow();

      if (hideAfter) {
        hideTimer = setTimeout(() => {
          setDisplayChildren(false);
          if (onHide) onHide();

          if (removeAfter) {
            removeTimer = setTimeout(() => {
              if (onRemove) onRemove();
            }, removeAfter);
          }
        }, hideAfter);
      } else if (removeAfter) {
        removeTimer = setTimeout(() => {
          setDisplayChildren(false);
          if (onRemove) onRemove();
        }, removeAfter);
      }
    }, showAfter);

    return () => {
      clearTimeout(showTimer);
      hideTimer && clearTimeout(hideTimer);
      removeTimer && clearTimeout(removeTimer);
    };
  }, [showAfter, hideAfter, removeAfter, onShow, onHide, onRemove]);

  if (!displayChildren && !displayPlaceholder) return null;

  const result = displayPlaceholder ? (placeholder as ReactNode) : children;
  return result as ReactElement<any, any>;
};

export { Defer };
